import React, { useState, useEffect, useRef } from "react";
import ctl from "@netlify/classnames-template-literals";
import { PLink, Text } from "components";
import { SubMenu } from "./sub-menu";
import { headerMenu } from "config/menu";
import Arrow from "svgs/chevron-right.svg";

const MenuItems = () => {
  const [showSubmenu, setShowSubmenu] = useState(false);
  const [currentSubMenu, setCurrentSubMenu] = useState(null);

  const ref = useRef();

  useEffect(() => {
    const clickOutsideCheck = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setShowSubmenu(null);
      }
    };
    document.addEventListener("mousedown", clickOutsideCheck);

    return () => {
      document.removeEventListener("mousedown", clickOutsideCheck);
    };
  }, [showSubmenu]);

  const headerMenuValues = Object.values(headerMenu);
  const headerMenuTitles = Object.keys(headerMenu);

  const menuItems = headerMenuValues.map((item, index) => {
    const hasSubmenu = Array.isArray(item);
    const toggleSubMenu = index => {
      if (index !== currentSubMenu) {
        setCurrentSubMenu(index);
      } else {
        setCurrentSubMenu(null);
      }
    };

    const handleKeyDown = e => {
      if (e.keyCode === 13) {
        toggleSubMenu();
      }
    };

    const isSubMenuOpen = currentSubMenu === index;
    const menuHeadingStyle = ctl(`
    ${menuHeadingBaseStyle}
  
    `);
    return (
      <li className={itemWrapStyle} key={item.title}>
        {/* menu items */}
        {hasSubmenu ? (
          <button
            onClick={() => toggleSubMenu(index)}
            onKeyDown={() => handleKeyDown}
            className={menuItemWrapStyle}
          >
            <Text
              className={menuHeadingStyle}
              variant="p18"
              value={headerMenuTitles[index]}
              weight="400"
            />
            <Arrow
              className={`lg:hidden transition transform group-hover:stroke-primary ${
                isSubMenuOpen
                  ? "rotate-90 stroke-primary"
                  : "rotate-0 stroke-secondary"
              }`}
            />
          </button>
        ) : (
          <PLink {...item}>
            <Text
              className={menuHeadingStyle}
              variant="p18"
              value={headerMenuTitles[index]}
              weight="400"
            />
          </PLink>
        )}

        {hasSubmenu && <SubMenu items={item} menuOpen={isSubMenuOpen} />}
      </li>
    );
  });

  return (
    <ul ref={ref} className={menuItemStyle}>
      {menuItems}
    </ul>
  );
};

const itemWrapStyle = ctl(`
  group 
  list-none 
  cursor-default
  lg:py-7
  xl:mr-[56px]
  lg:mr-6
  pl-6
  lg:pl-0
`);

const menuHeadingBaseStyle = ctl(`
 max-w-max
lg:py-0
py-4
group-hover:!text-primary
transition
`);

const menuItemStyle = ctl(`
  lg:flex 
`);
const menuItemWrapStyle = ctl(`
  flex 
  items-center 
  group
`);

export { MenuItems };
